import Vue from "vue";
import VueRouter from "vue-router";
import CryptoJS from "crypto-js";

Vue.use(VueRouter);

const router = new VueRouter({
	mode: "history", // 使用 history 模式
	routes: [
		{
			path: "/login",
			name: "Login",
			component: () => import("@/views/login.vue"), // 登录页不使用 Layout
			meta: { noLayout: true }
		},
		{
			path: "/",
			component: () => import("@/layout/index.vue"), // 公共布局
			redirect: "/home",
			children: [
				{
					path: "home",
					name: "Home",
					meta: { title: "运营大厅" }, // 设置面包屑
					component: () => import("@/views/homePage/index.vue")
				},
				{
					path: "battery",
					name: "Battery",
					meta: { title: "电池监控" }, // 设置面包屑
					component: () => import("@/views/batteryPage/index.vue")
				},
				{
					path: "vehicle",
					name: "Vehicle",
					meta: { title: "车辆监控" }, // 设置面包屑
					component: () => import("@/views/vehiclePage/index.vue")
				},
				{
					path: "cabinet",
					name: "Cabinet",
					meta: { title: "换电柜监控" }, // 设置面包屑
					component: () => import("@/views/cabinetPage/index.vue")
				},
				{
					path: "fault",
					name: "Fault",
					meta: { title: "故障告警" }, // 设置面包屑
					component: () => import("@/views/faultPage/index.vue")
				},
				{
					path: "data",
					name: "Data",
					meta: { title: "数据中心" }, // 设置面包屑
					component: () => import("@/views/dataPage/index.vue")
				},
				{
					path: "cabinet-detail",
					name: "CabinetDetail",
					meta: {
						title: "换电柜监控",
						breadcrumb: [
							{ title: "换电柜监控", path: "/cabinet" },
							{ title: "换电柜实时监控" }
						]
					}, // 设置面包屑
					component: () => import("@/views/cabinetPage/detailNew.vue")
				},
				{
					path: "cabinet-detail0",
					name: "CabinetDetail",
					meta: {
						title: "换电柜监控",
						breadcrumb: [
							{ title: "换电柜监控", path: "/cabinet" },
							{ title: "换电柜实时监控" }
						]
					}, // 设置面包屑
					component: () => import("@/views/cabinetPage/detail.vue")
				}
			]
		},
		{
			path: "*", // 匹配所有未定义路由
			name: "NotFound",
			component: () => import("@/views/notFound.vue"),
			meta: { noLayout: true } // 可选：不使用 Layout
		}
	]
});

// 路由守卫：登录拦截
router.beforeEach((to, from, next) => {
	const KEY = to.query.KEY;

	if (KEY) {
		// 密钥要与加密时使用的密钥一致
		const SECRET_KEY = "my-secret-key";

		// 解密 KEY
		const decryptedToken = CryptoJS.AES.decrypt(KEY, SECRET_KEY).toString(
			CryptoJS.enc.Utf8
		);

		// 存储 Token 并清除 URL 中的参数
		localStorage.setItem("ACCESS_TOKEN", decryptedToken);
		// 新增：标记是通过KEY链接进入，用于Layout调整菜单
		localStorage.setItem("isFromKeyEntry", "true");
	}

	const token = localStorage.getItem("ACCESS_TOKEN");
	const whiteList = ["/login"]; // 不需要登录的页面

	if (token) {
		if (to.path === "/login") {
			// 已登录访问登录页，重定向首页
			next("/");
		} else {
			Vue.prototype.$store.commit("setPageLoading", true);
			next(); // 放行
		}
	} else {
		// 未登录
		if (whiteList.includes(to.path)) {
			next(); // 访问 login 页面放行
		} else {
			// 拦截到登录页，并带上 redirect 参数
			next(`/login?redirect=${to.fullPath}`);
		}
	}
});

router.afterEach(() => {
	setTimeout(() => {
		Vue.prototype.$store.commit("setPageLoading", false);
	}, 300);
});

export default router;
